<template>
	<div >
		<ul>
	        <base-dropdown class="ChatTopRightBtnWrp">
	            <div class="ChatTopRightBtn" slot="title">
               <img :src="require(`@/assets/icon/${icon}`)" alt="images" />
	            </div>

	            <template v-if="isBlockUser()==true">
	                <a href="#" @click="unBlock" class="dropdown-item">
	                	Unblock User
	                </a>
	                <router-link to="/notificatons/3" class="dropdown-item ">
	                    Report User
	                </router-link>
	            </template>
	            <template v-else>
	               <!--  <router-link to="/notificatons/1" class="dropdown-item ">
	                    Leave Group
	                </router-link> -->
	                <a href="#" @click="block" class="dropdown-item">
	                	Block
	                </a>
	                <router-link to="/notificatons/3" class="dropdown-item ">
	                    Block & Report
	                </router-link>
	            </template>
	        </base-dropdown>
	    </ul>
	</div>
</template>


<script>
  import { EventBus } from '../../main';
  export default {
      props: ['icon'],
      name: "block-unblock",

      data() {
          return {
          	blockUsers:[]
          }
      },

      methods: {
      	//view block user from localstorage 
        viewBlockUser() {
        	if(localStorage.getItem('blockedUsers')){
        		this.blockUsers = JSON.parse(localStorage.getItem('blockedUsers'));
        	}
        },

      	// store blocked user on the local storage
      	blockUser(){
        	let parsed = JSON.stringify(this.blockUsers);
        	localStorage.setItem('blockedUsers',parsed);
        	this.viewBlockUser();
      	},

      	// block user push to a array
      	block(){

      		if(this.blockUsers.length>0) {
      			for (var i = 0; i < this.blockUsers.length; i++) {
      				if(this.blockUsers[i]==this.$route.params.id) {
      					return;
      				} 
      			}
      		} 

      		this.blockUsers.push(this.$route.params.id);
      		this.blockUser();
      		this.isBlockUser();

      		EventBus.$emit('blockUsers', this.blockUsers);

      	},

        unBlock() {

      		if(this.blockUsers.length>0) {
      			for (var i = 0; i < this.blockUsers.length; i++) {
      				if(this.blockUsers[i]==this.$route.params.id) {
      					this.blockUsers.splice(i,1);
      				} 
      			}
      		}

        	this.blockUser();
      		this.isBlockUser();
      		EventBus.$emit('blockUsers', this.blockUsers);
        },

      	isBlockUser() {
      		if(this.blockUsers.length>0) {
      			for (var i = 0; i < this.blockUsers.length; i++) {
      				if(this.blockUsers[i]==this.$route.params.id) {
      					return true;
      				} 
      			}
      		}
      		return false;
      	},



      },

        mounted() {
           this.viewBlockUser();
           this.isBlockUser();

           EventBus.$on('unBlockUsers', data => {
             this.blockUsers=data;
             this.viewBlockUser();
             this.isBlockUser();  
           });

        },

  }
</script>
